import { ComponentProps } from "react";
import DotLoader from "./DotLoader.tsx";
import styles from "./CenteredDotLoader.module.scss";

export default function CenteredDotLoader(
  props: ComponentProps<typeof DotLoader>
) {
  return (
    <div className={styles.container}>
      <DotLoader {...props} />
    </div>
  );
}
